<template>
  <div class="container-failure">
    <van-dialog v-model="showCheckFailureDia" :showConfirmButton="false" :closeOnClickOverlay="true" @close="close">
      <div class="dialog">
        <div class="tit">{{ $t('lang.BaseCommon.k104') }}</div>
        <div class="con" v-html="$t('lang.OtherModule.k002')"></div>
        <div class="btn" @click="close">{{ $t('lang.BaseCommon.k039') }}</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  props: {
    showCheckFailureDia: {
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$parent.closeDia()
    },
  },
}
</script>
<style lang="scss" scoped>
.container-failure {
  .dialog {
    width: 100%;
    padding: 30px 20px;
  }
  .tit {
    width: 100%;
    font-size: 16px;
    font-family: 'Inter-Regular';
    font-weight: 600;
    color: #333333;
    line-height: 26px;
    text-align: center;
  }
  .con {
    width: 100%;
    margin: 16px 0 20px 0;
    font-size: 16px;
    font-family: 'Inter-Regular';
    font-weight: 400;
    color: #333333;
    line-height: 24px;
    text-align: left;
    > span {
      color: red;
    }
  }
  .btn {
    width: 250px;
    height: 40px;
    margin: 0 auto;
    line-height: 40px;
    text-align: center;
    background: #a338fc;
    border-radius: 20px;
    font-size: 16px;
    font-family: 'Inter-Regular';
    font-weight: 600;
    color: #ffffff;
  }
}
</style>
